import { getKeyIcon } from '@/lib/keyboard';
import { cva, VariantProps } from 'class-variance-authority';

const variants = cva(
  'text-bold inline-flex items-center justify-center rounded border border-black/10 bg-white px-1.5 py-0.5 font-mono text-[14px] font-semibold text-black shadow-[inset_0_-1px_0_0_rgba(0,0,0,0.2)] dark:border-white/20 dark:bg-black dark:shadow-[inset_0_-1px_0_0_rgba(255,255,255,0.1)]',
  {
    variants: {
      size: {
        default: 'min-w-[1.5rem] text-[11px]',
        sm: 'min-w-[1rem] text-[10px] leading-[12px] text-[9px] font-extrabold',
      },
    },
  }
);

export type KbdProps = { children: string } & VariantProps<typeof variants>;

export const Kbd = (props: KbdProps) => {
  return <kbd className={variants(props)}>{getKeyIcon(props.children.toUpperCase())}</kbd>;
};
